import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const applicationSchema = z.object({
  name: z.string().trim().min(2).max(100),
  company: z.string().trim().min(2).max(120),
  email: z.string().trim().email().max(255),
  whatsapp: z.string().trim().min(8).max(30),
  cityState: z.string().trim().min(2).max(120),
  instagram: z.string().trim().min(2).max(240),
  website: z.string().trim().max(240).optional(),
  participationMode: z.enum([
    "Quero enviar depoimentos em vídeo.",
    "Quero indicar novas empresas.",
    "Quero participar das duas modalidades.",
  ]),
  notes: z.string().trim().max(1500).optional(),
  utmSource: z.string().trim().max(120).optional(),
  utmMedium: z.string().trim().max(120).optional(),
  utmCampaign: z.string().trim().max(120).optional(),
});

export const submitAmbassadorApplication = createServerFn({ method: "POST" })
  .inputValidator((input) => applicationSchema.parse(input))
  .handler(async ({ data }) => {
    const { getServerSupabase } = await import("./supabase.server");
    const supabase = getServerSupabase();

    const utmSource = data.utmSource ?? null;
    const utmMedium = data.utmMedium ?? null;
    const utmCampaign = data.utmCampaign ?? null;

    const { error } = await supabase.from("ambassador_applications").insert({
      name: data.name,
      company: data.company,
      email: data.email,
      whatsapp: data.whatsapp,
      city_state: data.cityState,
      instagram: data.instagram,
      website: data.website || null,
      participation_mode: data.participationMode,
      notes: data.notes || null,
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
      landing_page: "/embaixadores",
      status: "new",
    });

    if (error) throw new Error("Não foi possível registrar a solicitação.");

    // The saved application remains available even if spreadsheet delivery fails.
    const lovableKey = process.env["LOVABLE_API_KEY"];
    const sheetsKey = process.env["GOOGLE_SHEETS_API_KEY"];
    if (!lovableKey || !sheetsKey) {
      console.error("Google Sheets connection is unavailable for ambassador applications.");
      return { success: true, sheetSynced: false };
    }

    const values = [[
      new Date().toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" }),
      data.name, data.company, data.email, data.whatsapp, data.cityState,
      data.instagram, data.website || "", data.participationMode, data.notes || "",
      utmSource || "", utmMedium || "", utmCampaign || "", "/embaixadores", "new",
    ]];

    try {
      const response = await fetch(
        "https://connector-gateway.lovable.dev/google_sheets/v4/spreadsheets/1vuZkGcZUOciLjxeQfboEIjLDjykDGFHTRxigEojU4Ss/values/Embaixadores!A:O:append?valueInputOption=RAW&insertDataOption=INSERT_ROWS",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${lovableKey}`,
            "X-Connection-Api-Key": sheetsKey,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ values }),
        },
      );
      if (!response.ok) {
        console.error(`Google Sheets ambassador append failed [${response.status}]: ${await response.text()}`);
        return { success: true, sheetSynced: false };
      }
      return { success: true, sheetSynced: true };
    } catch (sheetError) {
      console.error("Google Sheets ambassador append failed:", sheetError);
      return { success: true, sheetSynced: false };
    }
  });
